var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeSke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 706,
    viewBox: "0 0 613 706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 613,
    height: 706,
    rx: 10,
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 41,
    width: 428,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 58,
    width: 428,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 74,
    width: 428,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 91,
    width: 428,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 107,
    width: 428,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 124,
    width: 428,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 199,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 199,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 347,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 347,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 496,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 496,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 216,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 216,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 364,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 364,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 512,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 512,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 232,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 232,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 380,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 380,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 529,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 529,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 248,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 248,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 397,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 397,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 545,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 545,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 265,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 265,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 413,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 413,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 561,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 561,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 281,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 281,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 430,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 430,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 578,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 578,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 638,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 298,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 298,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 446,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 446,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 594,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 594,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 655,
    width: 267,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 39,
    width: 95,
    height: 93,
    rx: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeSke);
export default __webpack_public_path__ + "static/media/resume-ske.306ced1a6d03e9215508d09e1eca8513.svg";
export { ForwardRef as ReactComponent };